import React from 'react'
import PerfectScrollbar from 'react-perfect-scrollbar'
import {
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  CardActions,
  TablePagination,
} from '@material-ui/core'
import { send } from 'helpers/utils'
import { UserReportStatus, UserReportType } from 'common/enum'
import { formatDateTime } from 'common/usual'

const WorkoutCategory = (props) => {
  const { data, page, onPageChange } = props

  return (
    <Card>
      <CardContent className={'table-content'}>
        <PerfectScrollbar>
          <div className={'inner'}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>ID</TableCell>
                  <TableCell>Reporter ID</TableCell>
                  <TableCell>Poster ID</TableCell>
                  <TableCell>Post ID</TableCell>
                  <TableCell>Comment ID</TableCell>
                  <TableCell>Comment</TableCell>
                  <TableCell>Description</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Created At</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {((data && data.rows) || []).map(record => (
                    <TableRow key={record.id} hover onClick={() => props.history.push(`/social-feed/reports/${record.id}`)} className={'cursor-pointer'} >
                      <TableCell>{record.id}</TableCell>
                      <TableCell>{record.userId}</TableCell>
                      <TableCell>{record.targetUserId}</TableCell>
                      <TableCell>{record.type === UserReportType.SocialFeed && record.reportId}</TableCell>
                      <TableCell>{record.type === UserReportType.SocialComment && record.reportId}</TableCell>
                      <TableCell>{record.comment}</TableCell>
                      <TableCell className='line-break-anywhere'>{send((record.socialFeedPost || record.socialFeedComment), 'description')}</TableCell>
                      <TableCell>{UserReportStatus[record.status]}</TableCell>
                      <TableCell>{formatDateTime(record.createdAt)}</TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </div>
        </PerfectScrollbar>
      </CardContent>
      <CardActions className={'flex-right'}>
        <TablePagination
          component="div"
          count={(data && data.count) || 0}
          onChangePage={onPageChange}
          page={page - 1}
          rowsPerPage={10}
          rowsPerPageOptions={[10]}
        />
      </CardActions>
    </Card>
  )
}

export default WorkoutCategory
